// eslint-disable-next-line no-restricted-imports
import { Segment } from 'semantic-ui-react';

import PageHeader from '../../Components/Shared/PageHeader';
import TransactionsList from './TransactionsList';

import { useOrganization } from '../../hooks/useOrganizations';
import { PAGE_NAMES, useSegmentPage } from '../../segment';

export default function TransactionsPage() {
  const organization = useOrganization();
  useSegmentPage(PAGE_NAMES.transactions);

  return (
    <>
      <Segment basic>
        <PageHeader pageName={PAGE_NAMES.transactions} classes="transactions" />
        <TransactionsList organization={organization} />
      </Segment>
    </>
  );
}
